const enum TaskTimeStatusEnums {
  PLANNED = 'PLANNED',
  REALIZED = 'REALIZED',
  LIST = 'LIST',
}

export default TaskTimeStatusEnums;
